/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_UnavailableInputs */

const th_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบการแข่งขันนี้`)
};

const en_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This game is unavailable.`)
};

const ja_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この試合は表示できません。`)
};

const zh_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此比赛不可用。`)
};

const es_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este partido no está disponible.`)
};

const pt_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este jogo não está disponível.`)
};

const id_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan ini tidak tersedia.`)
};

const fr_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce match n’est pas disponible.`)
};

const tl_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available ang larong ito.`)
};

const vi_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trận này không khả dụng.`)
};

const ko_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 경기는 이용할 수 없습니다.`)
};

const de_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Spiel ist nicht verfügbar.`)
};

const ru_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот матч недоступен.`)
};

const tr_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu maç kullanılamıyor.`)
};

const it_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa partita non è disponibile.`)
};

const pl_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten mecz jest niedostępny.`)
};

const uk_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей матч недоступний.`)
};

const hi_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मैच उपलब्ध नहीं है।`)
};

const ar_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه المباراة غير متاحة.`)
};

const ms_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan ini tidak tersedia.`)
};

const bn_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলাটি পাওয়া যাচ্ছে না।`)
};

const zh_tw2_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這場比賽無法使用。`)
};

const zh_hk2_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這場比賽無法使用。`)
};

const ur_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ میچ دستیاب نہیں۔`)
};

const fa_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این بازی در دسترس نیست.`)
};

const sw_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezo huu haupatikani.`)
};

const nl_game_unavailable = /** @type {(inputs: Game_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze wedstrijd is niet beschikbaar.`)
};

/**
* | output |
* | --- |
* | "This game is unavailable." |
*
* @param {Game_UnavailableInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const game_unavailable = /** @type {((inputs?: Game_UnavailableInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_UnavailableInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_game_unavailable(inputs)
	if (locale === "ja") return ja_game_unavailable(inputs)
	if (locale === "zh") return zh_game_unavailable(inputs)
	if (locale === "es") return es_game_unavailable(inputs)
	if (locale === "pt") return pt_game_unavailable(inputs)
	if (locale === "id") return id_game_unavailable(inputs)
	if (locale === "fr") return fr_game_unavailable(inputs)
	if (locale === "tl") return tl_game_unavailable(inputs)
	if (locale === "vi") return vi_game_unavailable(inputs)
	if (locale === "ko") return ko_game_unavailable(inputs)
	if (locale === "de") return de_game_unavailable(inputs)
	if (locale === "ru") return ru_game_unavailable(inputs)
	if (locale === "tr") return tr_game_unavailable(inputs)
	if (locale === "it") return it_game_unavailable(inputs)
	if (locale === "pl") return pl_game_unavailable(inputs)
	if (locale === "uk") return uk_game_unavailable(inputs)
	if (locale === "hi") return hi_game_unavailable(inputs)
	if (locale === "ar") return ar_game_unavailable(inputs)
	if (locale === "ms") return ms_game_unavailable(inputs)
	if (locale === "bn") return bn_game_unavailable(inputs)
	if (locale === "zh-TW") return zh_tw2_game_unavailable(inputs)
	if (locale === "zh-HK") return zh_hk2_game_unavailable(inputs)
	if (locale === "ur") return ur_game_unavailable(inputs)
	if (locale === "fa") return fa_game_unavailable(inputs)
	if (locale === "sw") return sw_game_unavailable(inputs)
	if (locale === "nl") return nl_game_unavailable(inputs)
	return en_game_unavailable(inputs)
});